module.exports = __webpack_public_path__ + "img/huiyuankaitong.7b201ad1.png";